import axios from "axios";

export function getAllPeople() {
  return axios.get("people-list").then(it => it.data);
}
